/* ARKSTUDIOS — Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Drop-Day Gate ───────────────────────────────── */
  var IS_DROP_DAY = window.ARKSTUDIOS_DROP_DAY || false;

  if (IS_DROP_DAY) {
    var splashScroll = document.getElementById('splashScroll');
    var splashGate   = document.getElementById('splashGate');
    if (splashScroll) splashScroll.style.display = 'none';
    if (splashGate)   splashGate.style.display   = 'flex';
  }

  /* ── Mobile Menu ─────────────────────────────────── */
  window.openMobile = function () {
    var overlay = document.getElementById('mobileOverlay');
    if (overlay) {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeMobile = function () {
    var overlay = document.getElementById('mobileOverlay');
    if (overlay) {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  /* ── Ticker ──────────────────────────────────────── */
  var tickerWrap  = document.querySelector('.ticker-wrap');
  var tickerTrack = document.querySelector('.ticker-track');
  if (tickerWrap && tickerTrack) {
    var original = tickerTrack.innerHTML;

    // Clone until one set is wider than the viewport
    while (tickerTrack.scrollWidth < tickerWrap.offsetWidth + 40) {
      tickerTrack.innerHTML += original;
    }

    // Record one set's width, then duplicate for seamless loop
    var setWidth = tickerTrack.scrollWidth;
    tickerTrack.innerHTML += tickerTrack.innerHTML;

    // Set translate and speed (80px/s)
    tickerTrack.style.setProperty('--ticker-translate', '-' + setWidth + 'px');
    var duration = Math.round(setWidth / 40);
    tickerTrack.style.animationDuration = duration + 's';
  }

  /* ── Email Signup ────────────────────────────────── */
  var emailForm = document.getElementById('emailSignupForm');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = emailForm.querySelector('.email-field');
      if (!input || !input.value) return;
      // Redirect to Shopify customer registration or newsletter
      window.location.href = '/account/register?email=' + encodeURIComponent(input.value);
    });
  }

});
